// starfield.jsx
import { Vortex } from "../ui/vortex";

export function HeroVortex() {
  return (
    <div className="absolute inset-0 z-0 pointer-events-none">
      <Vortex
        className="h-full w-full"
      />
    </div>
  );
}